<template>
  <div class="modal" @click.self="$emit('hide')">
    <div class="modal-content" @click.self="$emit('hide')">
      <div class="project-logo-overlay">
        <img v-if="projectLogo" :src="projectLogo" class="project-logo" alt="" />
        <project-logo v-else class="project-logo-empty" :project-name="projectName"/>
      </div>
      <div class="project-name">{{ projectName }}</div>
      <div v-if="isSelfEmployed" class="project-badge">
        <div class="badge-container">
          <div class="badge-icon"></div>
          <div class="badge-text">{{ $t('self.employed') }}</div>
        </div>
      </div>
      <div class="project-description">{{ projectDescription }}</div>
      <div class="project-footer">
        <button class="project-footer-button" @click="$emit('hide')">{{ $t('common.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectLogo from 'organisms/project/components/ProjectLogo';
export default {
  name: 'ProjectInformationModal',
  components: { ProjectLogo },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    projectLogo() {
      return this.project.projectLogo || this.project.project_logo;
    },
    projectName() {
      return this.project.projectName || this.project.project_name;
    },
    displayShortProjectName() {
      return this.projectName.charAt(0).toLowerCase();
    },
    projectDescription() {
      return this.project.projectDescription || this.project.project_description;
    },
    isSelfEmployed() {
      return this.project.selfEmployed;
    },
  },
};
</script>

<style lang="sass" scoped>
  @mixin full-size($pos: absolute, $val: 0)
    position: $pos
    @if $val
      top: $val
      left: $val
      right: $val
      left: $val

  @mixin flex-center
    display: flex
    justify-content: center
    align-items: center

  .modal
    +full-size(fixed)
    +flex-center
    width: 100%
    height: 100vh
    z-index: 1000
    background: rgba(238, 238, 238, 0.65)
    overflow: hidden
    color: #212121

  .modal-content
    width: 344px
    margin: 0 auto
    padding: 15px
    background: #fff
    overflow: hidden
    border-radius: 4px

    @media (max-width: 479px)
      border-radius: 0

  .project-name
    margin-bottom: 10px
    font-weight: 600
    font-size: 24px
    line-height: 40px
    color: #212121
    text-align: center

  .project-description
    margin-bottom: 10px
    font-size: 14px
    line-height: 20px
    color: #212121

  .project-logo-overlay
    margin-bottom: 10px

  .project-logo
    max-width: 320px
    max-height: none
    width: 100%

  .project-logo-empty
    max-width: 320px
    max-height: none
    justify-content: center
    margin: 0 auto;

  .project-badge
    margin-bottom: 23px
    text-align: center

  .badge-container
    display: inline-flex
    justify-content: space-between
    background: #DFDFE2
    border-radius: 50px

  .badge-icon
    width: 22px
    height: 22px
    background: #F6F6F6
    background-image: url('~@/assets/svg/self-employed.svg')
    background-position: center
    background-repeat: no-repeat
    background-size: auto
    border-radius: 50%

  .badge-text
    padding: 1px 9px 1px 5px
    font-size: 14px
    line-height: 20px
    color: #212121

  .project-footer
    text-align: right

  .project-footer-button
    padding: 10px 20px
    font-size: 14px
    line-height: 17px
    color: #9B51E0
    background-color: transparent
</style>
